import ProfilePage from 'src/latest/src/features/profile/ProfilePage';
import TeletherapyContainer from 'src/latest/src/features/teletherapy/TeletherapyContainer';
import { SuperAdminDashboard } from 'src/latest/src/features/super-admin';
import { PracticeAdmin } from 'src/latest/src/features/practice-admin';
import { Resources } from '../features/resources';
import { BillingAdminDashboard } from 'src/latest/src/features/billing-admin';
import PaymentPage from '../features/payment/PaymentPage';

export const RouteConfig = {
  profilePage: {
    path: '/profile/:profileId',
    name: 'ProfilePage',
    component: ProfilePage,
  },
  teletherapy: {
    path: '/teletherapy/*',
    name: 'Teletherapy',
    component: TeletherapyContainer,
  },
  superAdmin: {
    path: '/super-admin/*',
    name: 'SuperAdmin',
    component: SuperAdminDashboard,
  },
  practiceAdmin: {
    path: '/practice-admin/*',
    name: 'PracticeAdmin',
    component: PracticeAdmin,
  },
  billingAdmin: {
    path: '/billing-admin/*',
    name: 'BillingAdmin',
    component: BillingAdminDashboard,
  },
  resources: {
    path: '/resources/*',
    name: 'Resources',
    component: Resources,
  },
  payments: {
    path: '/payment/*',
    name: 'Payment',
    component: PaymentPage,
  },
};
